if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        this.observer = null;

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        // Disconnect observer when hiding modal
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');
            requestAnimationFrame(() => {
              this.reinitializeProductInfo();
              this.initMediaGallery();
            });

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
            
            // Start observing DOM changes to remove unwanted elements
            this.startObserver();
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      startObserver() {
        this.removeUnwantedElements();

        if (this.observer) {
          this.observer.disconnect();
        }

        this.observer = new MutationObserver((mutations) => {
          this.removeUnwantedElements();
        });

        this.observer.observe(this.modalContent, {
          childList: true,
          subtree: true
        });
      }

     removeUnwantedElements() {
      const productCompareIcon = this.modalContent.querySelector('.pdp-compare-icon-btn');
      if (productCompareIcon) productCompareIcon.remove();

      // const price = this.modalContent.querySelector('.price');
      // if (price) price.remove();

      const priceTag = this.modalContent.querySelector('.price-tag');
      if (priceTag) priceTag.remove();

      const sliderArrow = this.modalContent.querySelector('.quick-add-hidden-slider');
      if (sliderArrow) sliderArrow.remove();

      const productAvailabilityActions = this.modalContent.querySelector('.product-availability__actions, .product__inquire-now');
      if (productAvailabilityActions) productAvailabilityActions.remove();

      const productDeliveryInfo = this.modalContent.querySelector('.product-availability__delivery-info');
      if (productDeliveryInfo) productDeliveryInfo.remove();

      const productAvailabilityInfo = this.modalContent.querySelector('.product-availability__call-to-check');
      if (productAvailabilityInfo) productAvailabilityInfo.remove();

      const hrActionButtons = this.modalContent.querySelectorAll('.horizontal-line');
      hrActionButtons.forEach((el) => el.remove());

      const productTypeEl = this.modalContent.querySelector('.quick-view-product-type');
      const productType = productTypeEl?.textContent?.trim();

      const accessoryTypes = [
        'Vehicle Accessories',
        'Rider Accessories',
        'Service Parts'
      ];

      if (accessoryTypes.includes(productType)) {
        const variantSelector = this.modalContent.querySelector('variant-selects');
        if (variantSelector) variantSelector.remove();
      } else {
        const description = this.modalContent.querySelector('.product__description');
        if (description) description.remove();
      }

      const quickViewParams = this.modalContent.querySelector('.quick-view-parameters');
      if (quickViewParams) quickViewParams.style.display = 'block';
    }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      initMediaGallery() {
        const mediaGalleries = this.modalContent.querySelectorAll('media-gallery');

        mediaGalleries.forEach((gallery) => {
          if (gallery && typeof gallery.init === 'function') {
            gallery.init();
          }
        });

        /* Fallback for slider */
        const sliders = this.modalContent.querySelectorAll('[id^="Slider-Gallery"]');
        sliders.forEach((slider) => {
          slider.dispatchEvent(new Event('change'));
        });
      }

      reinitializeProductInfo() {
        const productInfo = this.modalContent.querySelector('product-info');
        if (!productInfo) return;

        /* Trick Dawn into thinking section loaded */
        productInfo.dispatchEvent(
          new CustomEvent('shopify:section:load', {
            bubbles: true,
            detail: { sectionId: productInfo.dataset.section }
          })
        );

        /* Reconnect custom elements */
        productInfo.querySelectorAll('*').forEach((el) => {
          if (el.tagName.includes('-') && el.connectedCallback) {
            el.connectedCallback();
          }
        });
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}